import { render, staticRenderFns } from "./ModelBaseVulkan.vue?vue&type=template&id=3ab4f6c7&scoped=true"
import script from "./ModelBaseVulkan.vue?vue&type=script&lang=js"
export * from "./ModelBaseVulkan.vue?vue&type=script&lang=js"
import style0 from "./ModelBaseVulkan.vue?vue&type=style&index=0&id=3ab4f6c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab4f6c7",
  null
  
)

export default component.exports